import { computed, ref } from "@vue/composition-api";
import { ContentSet, InputContentSetUpdate } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import providers from "@/lib/api";

export default function usePostData() {
  const loading = ref<Promise<any>>(Promise.resolve());
  const postData = ref<ContentSet | null>(null);
  const isDraft = computed(() => !postData.value?.published);

  const requestAndSetPostData = async (postId: string, userId: string) => {
    const resp = await providers.ContentSetProvider.search({ data: { ids: [postId], userId } });
    postData.value = resp.result.find(i => i.id === postId) || null;
  };

  const createPost = async (type: ContentFeedTypeEnum, userId: string) => {
    postData.value = await providers.ContentSetProvider.create({ data: { type, userId } });
  };

  const deletePost = async () => {
    if (!postData.value) return;
    await providers.ContentSetProvider.delete({ id: postData.value.id });
  };

  const updatePost = async (data: Omit<InputContentSetUpdate, "id">) => {
    if (!postData.value) return;
    postData.value = await providers.ContentSetProvider.update({
      data: {
        ...data,
        id: postData.value.id,
      },
    });
  };

  const getPostData = async (data: { userId: string; postId: string }) => {
    loading.value = requestAndSetPostData(data.postId, data.userId);
    await loading.value;
  };

  return {
    loading,
    postData,
    isDraft,
    createPost,
    getPostData,
    updatePost,
    deletePost,
  };
}
